import '../../../../../es6/shared/jquery.onIntersection.js.es6';
import '../../../../../components/history-state.js.es6';
import '../../../../../es6/shared/temporary_storage_manager.js.es6';
import '../../../../../es6/shared/in-view.js.es6';
import '../../../../../js/views/room/truncate.js';
import '../../../../../js/views/room/modal.js.es6';
import '../../../../../es6/views/quick_estimate/form_data_keeper.js.es6';
import '../../../../../es6/views/quick_estimate/google.js.es6';
import '../../../../../es6/shared/social_login_error.js.es6';
import '../../../../../es6/shared/apple_login_manager.js.es6';
import '../../../../../es6/views/quick_estimate/apple.js.es6';
import '../../../../../es6/views/room/hint_tooltips.js.es6';
import '../../../../../es6/views/login/facebook.js.es6';
import '../../../../../es6/views/login/facebook-auth.js.es6';
import '../../../../../components/send-enquiry.js.es6';
import '../../../../../components/stop_watch.js.es6';
import '../../../../../components/page-visibility-api.js.es6';
import '../../../../../components/visited-page-time-tracking.js.es6';
import '../../../../../components/room-cards-carousel.js.es6';
import '../../../../../components/room-pricing-table.js.es6';
import '../../../../../components/room-selection-tracking.es6';
import '../../../../../components/enquiry-tracking.js.es6';

import { roomPageMainInit } from '../room/dependencies/roompage.main.js';

roomPageMainInit(true);
